export const LOGIN = 'login';
export const REGISTRATION = 'registration';
export const EMAIL_CONFIRMATION = 'email-confirmation';
export const CABINET = 'cabinet';
export const PROJECTS = 'projects';
export const PARTNERS = 'partners';
export const PAYOUT = 'payout';
export const INVOICING = 'Invoicing';
export const SUBSCRIPTIONS = 'subscriptions';
export const TWO_FACTOR = 'profileTwoFactor';
export const TWO_FACTOR_AUTH = 'TwoFactorAuth';
export const PROFILE = 'profile';
export const IDENTITY = 'identity';
export const SELF_EMPLOYED = 'selfEmployed';
export const TIMEZONE = 'timezone';
